import { render, staticRenderFns } from "./SettingMail.vue?vue&type=template&id=5edee05d&scoped=true&"
import script from "./SettingMail.vue?vue&type=script&lang=js&"
export * from "./SettingMail.vue?vue&type=script&lang=js&"
import style0 from "./SettingMail.vue?vue&type=style&index=0&id=5edee05d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edee05d",
  null
  
)

export default component.exports